import * as yup from 'yup';
import { Fields } from '../models/fields';
import { useTranslation } from '~/shared/utils/translation';
import { passwordRegex } from '~/shared/utils';
import { checkForCommonPasswordHandler } from '~/shared/utils/commonPasswords';

export const useValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.Email]: yup.string().email(translate('message.emailValidationError')),

        [Fields.NewPassword]: yup
            .string()
            .test('not-common-password', translate('message.noCommonPassword'), (value) =>
                checkForCommonPasswordHandler(value),
            )
            // .required('')
            .matches(passwordRegex, translate('message.passwordValidationError')),

        /**/
        [Fields.RepeatPassword]: yup
            .string()
            .oneOf([yup.ref('newpassword'), null], translate('createAccount.passwordMismatch')),
    });
};

export const useResetPasswordValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.NewPassword]: yup
            .string()
            .required('')
            .test('not-common-password', translate('message.noCommonPassword'), (value) =>
                checkForCommonPasswordHandler(value),
            )
            .matches(passwordRegex, translate('message.passwordValidationError')),

        /**/
        [Fields.RepeatPassword]: yup
            .string()
            .required()
            .oneOf([yup.ref('newpassword'), null], translate('createAccount.passwordMismatch')),
    });
};
